export function formatNumber (num: number, showCurrency?: boolean) {
  const formattedNumber = new Intl.NumberFormat('ru-RU').format(num)
  return showCurrency ? `${formattedNumber} ₸` : formattedNumber
}
